'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function prepareSource(src) {
  if (typeof window === 'undefined' || !src) {
    return src;
  }

  var encodedSrc = src.indexOf('?') >= 0 ? encodeURIComponent(src) : src;

  if (src.indexOf('//') === 0) {
    return '' + window.location.protocol + encodedSrc;
  }

  return encodedSrc;
}

exports.prepareSource = prepareSource;